<button
  type="button"
  role="tab"
  class="ds-stat-tab__button"
  [class.ds-stat-tab__button--active]="active"
  [disabled]="disabled"
  [attr.aria-selected]="active"
  (click)="onSelect()"
>
  <span class="ds-stat-tab__top">
    <span class="ds-stat-tab__count ds-subtitle-xl">{{ count }}</span>
    <span *ngIf="badge" class="ds-stat-tab__badge">{{ badge }}</span>
  </span>
  <span class="ds-stat-tab__label ds-subtitle-xs"
    >{{ label }}<span *ngIf="live" class="ds-stat-tab__live" aria-hidden="true"></span
  ></span>
</button>
